/**
 * The areas of the Download module, in the order the sidebar and the page list them. One list, read by both the sidebar registry and the
 * Download page, so a row cannot exist in one and not the other. The ids are the ones the server's catalog uses (`AREAS` in
 * `backend/src/modules/platform/data-export/data-export.catalog.ts`).
 */
export type DownloadAreaId = 'op' | 'ip' | 'lab' | 'pharmacy' | 'finance' | 'patients' | 'hr' | 'masters' | 'audit';

export interface DownloadArea {
  id: DownloadAreaId;
  label: string;
  /** The sidebar row's short label. */
  short: string;
}

export const DOWNLOAD_AREAS: ReadonlyArray<DownloadArea> = [
  { id: 'op', label: 'Out-Patient (OP)', short: 'OP' },
  { id: 'ip', label: 'In-Patient (IP)', short: 'IP' },
  { id: 'lab', label: 'Laboratory', short: 'Laboratory' },
  { id: 'pharmacy', label: 'Pharmacy & Stores', short: 'Pharmacy & Stores' },
  { id: 'finance', label: 'Finance & Accounts', short: 'Finance & Accounts' },
  { id: 'patients', label: 'Patients & Clinical', short: 'Patients & Clinical' },
  { id: 'hr', label: 'HR & Workforce', short: 'HR & Workforce' },
  { id: 'masters', label: 'Masters & Setup', short: 'Masters & Setup' },
  { id: 'audit', label: 'Audit & System', short: 'Audit & System' },
];

export const DOWNLOAD_PATH = '/download';
